import { render, staticRenderFns } from "./SearchSorting.vue?vue&type=template&id=186d39ca&"
import script from "./SearchSorting.vue?vue&type=script&lang=js&"
export * from "./SearchSorting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/juhani/ddev/aidian-website/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('186d39ca', component.options)
    } else {
      api.reload('186d39ca', component.options)
    }
    module.hot.accept("./SearchSorting.vue?vue&type=template&id=186d39ca&", function () {
      api.rerender('186d39ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/SearchSorting.vue"
export default component.exports